module.exports = __webpack_public_path__ + "media/flat tumor.4cf000e8.wav";